import HTTP from "@/_helpers/http";
import { CITIES__API } from "@/_helpers/urls";
import { CITIES__MUTATIONS } from "../mutation-types";
import { CITIES__ACTIONS } from "../action-types";

// State
const state = {
  cities: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [CITIES__MUTATIONS.CITIES](state, data) {
    state.cities = data;
  },
};

// Actions
const actions = {
  async [CITIES__ACTIONS.CITIES]({ commit, state }, id) {
    try {
      const url = `${CITIES__API.CITIES}/${id}`;
      const response = await HTTP().get(url);

      if (response.status === 200) {
        commit(CITIES__MUTATIONS.CITIES, response.data);
      } else {
        commit(CITIES__MUTATIONS.CITIES, []);
      }
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
